 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"vendors~ArtworkApp~OrderApp~Routes-Accept~Routes-ConfirmBid~Routes-Counter~Routes-NewPayment~Routes-~3db952b4","3":"vendors~Routes-Accept~Routes-Counter~Routes-NewPayment~Routes-Offer~Routes-Payment~Routes-Reject~Rou~78cda7cb","4":"vendors~ArtistApp~ArtworkApp~Routes-Collect~Routes-Collection~Routes-Collections~Routes-Overview~Rou~30c47d99","5":"vendors~ArtistApp~ArtworkApp~Routes-Collection~Routes-Overview~Routes-Works","6":"vendors~ArtistApp~ArtworkApp~Routes-Collect~Routes-Collection~Routes-Collections","7":"vendors~OrderApp~Routes-ConfirmBid~Routes-NewPayment~Routes-Payment~Routes-Register","8":"vendors~Routes-Accept~Routes-Counter~Routes-NewPayment~Routes-Reject~Routes-Respond","9":"vendors~Routes-Collect~Routes-Collection~Routes-Collections","10":"vendors~Routes-Collect~Routes-Works","11":"vendors~Routes-ConfirmBid~Routes-Register","12":"vendors~Routes-Overview~Routes-Works","13":"vendors~Routes-Reject~Routes-Respond","14":"ArtworkApp","15":"IdentityVerificationApp","16":"Routes-Collect","17":"Routes-Collection","18":"Routes-Collections","19":"Routes-NewPayment","20":"Routes-Overview","21":"Routes-Reject","22":"Routes-Works","60":"vendors~ArtistApp","61":"vendors~Components-AuctionFAQ","62":"vendors~ConversationApp","63":"vendors~OrderApp","64":"vendors~Routes-Accept","65":"vendors~Routes-Articles","66":"vendors~Routes-AuctionResults","67":"vendors~Routes-CV","68":"vendors~Routes-ConfirmBid","69":"vendors~Routes-Conversation","70":"vendors~Routes-Counter","71":"vendors~Routes-Offer","72":"vendors~Routes-Payment","73":"vendors~Routes-Review","74":"vendors~Routes-Shipping","75":"vendors~Routes-Shows","76":"vendors~Routes-Status"}[chunkId]||chunkId) + ".22820." + {"2":"17c0b22a7d1b49564220","3":"29b529c8b86ddd4a96a9","4":"026b2d55d664a4ff7624","5":"ac8266003baa1b130d9c","6":"834bb255fa2aa58f3280","7":"f921f21e6faa230f76f1","8":"ec6308278356001e3aa8","9":"17fc268364f5ee170c58","10":"5347053fe0ea979a5927","11":"aeae0fcc2b0cb7e306d4","12":"d30497c5aaf775942370","13":"1f8dab7023244cea4d45","14":"cb3338017f0a00f3aabc","15":"480c522c3f14d6ef84b0","16":"8f4441bce1834f939984","17":"434bd5759fbe9713345f","18":"396f5b1a9d7c2c7180ba","19":"e4423b0e03b172bd1459","20":"93cbf4c8112977b21b3d","21":"fd0da7a827977e972e8c","22":"b75fef50a768ab6ecc57","60":"ed374b130cf7791121ae","61":"593af5fd5a6dbce50320","62":"912e02c2d309c92825cb","63":"32f198145c8097c4c3d0","64":"e367c10c66db5a03c0d6","65":"daea32e5e4dfa3dca963","66":"18c696f56bbb93dd4f32","67":"ef033c8dc8fdedad5bf2","68":"fd00f6f2e1d54f630575","69":"efd5d2ad2cf9d91625af","70":"bd0a517459611e87fac4","71":"721fabda09ae1fcc7f05","72":"aad1b98db94d6e4cc1c7","73":"a2c65c98ae740b10b92f","74":"4bafe51537c7d57a0d23","75":"60464dc132af2ae6cd64","76":"be3a1ff70de203725c07"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
